/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonActiveUserCountInfo } from '../models/BabylonActiveUserCountInfo';
import type { BabylonAddressBtcStakerSummary } from '../models/BabylonAddressBtcStakerSummary';
import type { BabylonAddressDetailInfo } from '../models/BabylonAddressDetailInfo';
import type { BabylonAddressListInfo } from '../models/BabylonAddressListInfo';
import type { BabylonBtcStakerListInfo } from '../models/BabylonBtcStakerListInfo';
import type { BabylonBtcStakingOverviewListInfo } from '../models/BabylonBtcStakingOverviewListInfo';
import type { BabylonBtcStakingTransactionListInfo } from '../models/BabylonBtcStakingTransactionListInfo';
import type { BabylonTrxListInfo } from '../models/BabylonTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonAddressControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns BabylonAddressDetailInfo OK
     * @throws ApiError
     */
    public getBabylonAddressDetail({
        address,
    }: {
        address: string,
    }): CancelablePromise<BabylonAddressDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address',
            query: {
                'address': address,
            },
        });
    }

    /**
     * @returns BabylonTrxListInfo OK
     * @throws ApiError
     */
    public getBabylonAddressTransactionList({
        address,
        page = 1,
        size = 25,
    }: {
        address: string,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address/transaction/list',
            query: {
                'address': address,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonAddressListInfo OK
     * @throws ApiError
     */
    public getBabylonAddressList({
        sortField = 'BALANCE',
        sortDirection = 'DESC',
        page = 1,
        size = 25,
    }: {
        sortField?: 'BALANCE',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonAddressListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address/list',
            query: {
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBtcStakingTransactionListInfo OK
     * @throws ApiError
     */
    public getBabylonBtcStakingTransactionListByAddress1({
        address,
        status,
        page = 1,
        size = 25,
    }: {
        address: string,
        status?: Array<'PENDING' | 'VERIFIED' | 'ACTIVE' | 'UNBONDING' | 'WITHDRAWABLE' | 'WITHDRAWN' | 'UNBONDED' | 'EXPIRED' | 'EXPANDED' | 'SLASHED'>,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcStakingTransactionListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address/btc/staking/transaction/list',
            query: {
                'address': address,
                'status': status,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonAddressBtcStakerSummary OK
     * @throws ApiError
     */
    public getBabylonBtcStakerSummary(): CancelablePromise<BabylonAddressBtcStakerSummary> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address/btc/staking/summary',
        });
    }

    /**
     * @returns BabylonBtcStakingOverviewListInfo OK
     * @throws ApiError
     */
    public getBabylonBtcStakingOverviewListByAddress({
        address,
        sortField = 'STAKING_VALUE',
        sortDirection = 'DESC',
        page = 1,
        size = 25,
    }: {
        address: string,
        sortField?: 'STAKING_VALUE' | 'STAKING_COUNT',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcStakingOverviewListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address/btc/staking/overview/list',
            query: {
                'address': address,
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBtcStakerListInfo OK
     * @throws ApiError
     */
    public getBabylonBtcStakerList({
        sortField = 'STAKING_VALUE',
        sortDirection = 'DESC',
        page = 1,
        size = 25,
    }: {
        sortField?: 'STAKING_VALUE' | 'FP_COUNT',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcStakerListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address/btc/staking/address/list',
            query: {
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonActiveUserCountInfo OK
     * @throws ApiError
     */
    public getBabylonActiveUserCount1({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<BabylonActiveUserCountInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/address/active',
            query: {
                'targetDate': targetDate,
            },
        });
    }

}
